module.exports = __webpack_public_path__ + "static/media/pending.afd632ed.svg";